import { cn } from '@/lib';
import type { ReactNode } from 'react';

export interface CardProps {
    children: ReactNode;
    className?: string;
    padding?: 'none' | 'sm' | 'md' | 'lg';
    style?: React.CSSProperties;
}

const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-6 sm:p-8',
    lg: 'p-8 sm:p-10',
};

export function Card({ children, className, padding = 'md', style }: CardProps) {
    return (
        <div
            className={cn(
                'bg-surface rounded-lg border border-border shadow-sm',
                paddingClasses[padding],
                className
            )}
            style={style}
        >
            {children}
        </div>
    );
}
